import { createWebHashHistory, createRouter } from 'vue-router'
import { handleScroll } from '@helpers/utils.js'
import routes from '@router/allRoutes.js'
import { authStore } from '@stores'
import { ref } from 'vue'
import {
  containerScroll,
  containerHeight,
  sendMessage,
} from '@composables/useWindowEvents.js'

export const profileFrom = ref(undefined)

const savedScrollPositions = new Map()
const { isLoggedIn } = authStore()

let tryScrollCount = 0
function tryScroll(scrollAmount) {
  if (containerHeight.value > scrollAmount) {
    sendMessage({ modioScroll: scrollAmount })
  } else if (tryScrollCount < 3) {
    // Retry a few times if necessary.
    setTimeout(() => tryScroll(scrollAmount), 100)
    tryScrollCount++
  }
}

const router = new createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: (to, from, savedPos) => {
    const key = from.path + '|' + to.path
    // If used browser back button, scroll to saved postiion
    if (savedPos && savedScrollPositions.has(key)) {
      // Scroll at next event cycle.
      tryScrollCount = 0
      const scrollAmount = savedScrollPositions.get(key)
      setTimeout(() => tryScroll(scrollAmount))

      savedScrollPositions.delete(key)
    } else {
      if (from.name?.includes('browse') || from.name?.includes('library')) {
        if (to.name?.includes('browse')) return
        if (to.name?.includes('library')) return
      }
      if (containerScroll.value.frameTop < -100) {
        handleScroll(to, from)
      }
    }
  },
})

router.beforeEach((to) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn.value) {
      return { path: '/' }
    }
  }
})

router.afterEach((to, from) => {
  // used to ensure back button on UserView returns out of user profile
  if (to.path.includes('/u/') && !from.path.includes('/u/')) {
    profileFrom.value = from
  }

  savedScrollPositions.set(
    to.path + '|' + from.path,
    containerScroll.value.scrollY || 0
  )
  sendMessage({ modioPage: to.fullPath })
})

export default router
